import { IOpenShift } from "~/api/openShift";
import { IUser } from "~/api/user";

import { EStaffTypeKey } from "@/common/types";

// All versions of event payloads should be defined here
type TPayloadV1 = {
  openShift: Pick<
    IOpenShift,
    | "id"
    | "scheduleId"
    | "shiftType"
    | "durationSeconds"
    | "staffCategoryKey"
    | "shiftIncentiveLevelId"
    | "note"
    | "shiftCount"
    | "date"
    | "startDateTime"
  > & {
    staffTypeKey?: EStaffTypeKey;
    isAutoGenerated: boolean;
  };
  origin: TOpenShiftOrigin;
};

type TOpenShiftOrigin =
  | {
      type: "bulk-save-action";
      id?: never;
    }
  | {
      type: "schedule-targets-updated";
      id: IOpenShift["id"];
    }
  | {
      type: "schedule-updated";
      id: IOpenShift["id"];
    }
  | {
      type: "approved-open-shift-request";
      id: IOpenShift["id"];
    }
  | {
      type: "principal-staff-job-changed";
      id: IUser["id"];
    };

export namespace OpenShiftDeleted {
  export enum EVersions {
    "v1" = "1",
  }

  export type OpenShiftOrigin = TOpenShiftOrigin;
  export type Payloads = TPayloadV1;
  export type PayloadByVersion = {
    [EVersions.v1]: TPayloadV1;
  };
}
